import { BackdropDirective } from './backdrop.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BackdropDirective],
  exports: [BackdropDirective]
})
export class BackdropModule {
}
